// @ts-nocheck

import styled, { css } from 'styled-components';

import { Target } from '../../client';

export const MenuStyle = styled.div`
  border-radius: 4px;
  padding-bottom: 0;
  box-sizing: border-box;

  .wrap-betting-menu {
    border-radius: 2px;
    border: 1px solid #dad8de;
    overflow: hidden;
  }

  button {
    background: transparent;
    text-align: left;
    width: 100%;
    padding: 0;
    line-height: 1;
    border-radius: 0;
  }

  .with-direct {
    display: table;
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;

    .main,
    .sport-title {
      vertical-align: middle;
      display: table-cell;
      border-radius: 0;
      width: calc(100% - 40px);
    }

    .direct-route {
      border-left: solid 1px #ccc;
      display: table-cell;

      svg.icon {
        margin-left: 10px;
        margin-right: 8px;
      }
    }

    &.no-border {
      .direct-route {
        border-left: 0;
      }
    }
  }

  .left-of-arrow {
    display: inline-block;
    width: calc(100% - 40px);
  }

  .direct-arrow {
    float: right;
    svg.icon {
      margin-left: 12px;
      margin-right: 0;
    }
  }

  .direct-arrow,
  .direct-route {
    cursor: pointer;
    vertical-align: middle;
    width: 30px;
    border-radius: 0;
    text-align: center;
    svg.icon {
      width: 12px;
      display: inline-block;
      vertical-align: bottom;
      float: none;
      use.icon {
        fill: #333;
      }
    }
  }

  .sport {
    border-bottom: 1px solid #dad8de;

    &:first-child {
      border-top: 0;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  .sport-title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    padding: 5px;
    color: #333;
    background: #f2f2f2;
    cursor: pointer;

    .count {
      font-size: 12px;
    }

    ${Target.__MOBILE__
      ? css`
          &:active {
            background: #fff;

            .direct-route {
              background-color: #fff;
            }
          }
        `
      : css`
          &:hover {
            background: #fff;

            .direct-route {
              background-color: #fff;
            }
          }
        `}
  }

  .sport-with-direct.with-direct {
    background: #f2f2f2;

    ${Target.__MOBILE__
      ? undefined
      : css`
          .direct-route:hover {
            background-color: #fff;
          }
        `}
  }

  .sport.open .sub-nav {
    display: block;
  }

  .sport.open.active {
    .sport-title {
      color: $red;
    }
  }

  .sub-nav {
    li {
      background: #fafafa;
      border-top: solid 1px #ddd;

      .main {
        font-size: 13px;
        padding: 10px;
        font-weight: 600;
        cursor: pointer;
        text-align: left;
        color: #333;

        ${Target.__MOBILE__
          ? undefined
          : css`
              &:hover {
                background: #eee;
              }
            `}
      }
      .competitions {
        .direct-route {
          ${Target.__MOBILE__
            ? undefined
            : css`
                &:hover {
                  background: transparent;
                }
              `}
        }
      }
      .direct-route {
        ${Target.__MOBILE__
          ? undefined
          : css`
              &:hover {
                background: #eee;
              }
            `}
      }
    }

    .competitions {
      li {
        a {
          display: inline-block;
        }
        svg.icon {
          margin-left: 0;
          width: 12px;
          float: right;
          margin-right: 15px;
          use.icon {
            fill: #333;
          }
        }

        ${Target.__MOBILE__
          ? css`
              &:active {
                a {
                  color: $red;
                }
                svg.icon {
                  use.icon {
                    fill: $red;
                  }
                }
              }
            `
          : css`
              &:hover {
                a {
                  color: $red;
                }
                svg.icon {
                  use.icon {
                    fill: $red;
                  }
                }
              }
            `}
      }
    }

    .expandable {
      .competitions {
        display: none;
      }

      &.open .competitions {
        display: block;
      }
    }

    .competitions {
      li {
        background: #fff;
        border-top: solid 1px #ddd;

        a {
          font-size: 13px;
          color: $dark;
          font-weight: normal;
          cursor: pointer;
          display: table;

          &:hover {
            color: $red;
            background-color: transparent;

            svg.icon {
              margin: 0;
            }
          }

          .menu-name,
          .menu-icon {
            display: table-cell;
            vertical-align: middle;
          }

          .menu-name {
            width: 100%;
            padding: 10px;
          }

          svg.icon {
            padding: 0px 8px 0px 10px;
            display: inline-block;
            vertical-align: bottom;
            float: none;
            margin: 0;
          }
        }
      }
    }
  }

  .filter-checkbox {
    float: right;
    display: none;
  }

  input[type='checkbox'] + label {
    float: right;
    display: block;
    height: 11px;
    width: 11px;
    background: #fff;
    box-shadow: inset 0 1px 1px #ccc;
    cursor: pointer;
    text-indent: 0;
  }

  input[type='checkbox'] + label:hover {
    background: #eee;
  }

  input[type='checkbox'] + label .icon-ok {
    display: none;
    font-size: 12px;
    position: relative;
    left: -1px;
  }

  input[type='checkbox']:checked + label .icon-ok {
    display: block;
  }

  input[type='checkbox']:disabled + label {
    opacity: 0.5;
  }
`;
